/* Bespoke lightbox. Progressive enhancement: every zoomable image is a plain link to the large
   image, so without JavaScript (or <dialog> support) the link simply opens the image.
   The guard below lets several sections load this file without binding twice. */
(function () {
  if (window.__bspLightbox) return;
  window.__bspLightbox = true;

  var dlg, imgEl, capEl, countEl, prevBtn, nextBtn;
  var items = [], idx = 0, opener = null, touchX = null;

  var ICON_PREV = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  function preload(i) {
    var it = items[(i + items.length) % items.length];
    if (it) { var im = new Image(); im.src = it.href; }
  }

  function show(i) {
    idx = (i + items.length) % items.length;
    var it = items[idx];
    imgEl.src = it.href;
    imgEl.alt = it.getAttribute('data-alt') || '';
    capEl.textContent = it.getAttribute('data-caption') || '';
    capEl.hidden = !capEl.textContent;
    countEl.textContent = items.length > 1 ? (idx + 1) + ' of ' + items.length : '';
    prevBtn.hidden = nextBtn.hidden = items.length < 2;
    if (items.length > 1) { preload(idx + 1); preload(idx - 1); }
  }

  function step(d) { if (items.length > 1) show(idx + d); }

  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'bsp bsp-lb';
    dlg.setAttribute('aria-label', 'Image viewer');
    dlg.innerHTML =
      '<button type="button" class="bsp-lb__btn bsp-lb__close" aria-label="Close image viewer">' + ICON_CLOSE + '</button>' +
      '<button type="button" class="bsp-lb__btn bsp-lb__prev" aria-label="Previous image">' + ICON_PREV + '</button>' +
      '<figure class="bsp-lb__fig"><img class="bsp-lb__img" alt=""><figcaption class="bsp-lb__cap"></figcaption></figure>' +
      '<button type="button" class="bsp-lb__btn bsp-lb__next" aria-label="Next image">' + ICON_NEXT + '</button>' +
      '<p class="bsp-lb__count" aria-live="polite"></p>';
    document.body.appendChild(dlg);

    imgEl = dlg.querySelector('.bsp-lb__img');
    capEl = dlg.querySelector('.bsp-lb__cap');
    countEl = dlg.querySelector('.bsp-lb__count');
    prevBtn = dlg.querySelector('.bsp-lb__prev');
    nextBtn = dlg.querySelector('.bsp-lb__next');

    dlg.querySelector('.bsp-lb__close').addEventListener('click', function () { dlg.close(); });
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });

    // Clicking the dark area outside the picture closes the viewer.
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });

    dlg.addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
    }, { passive: true });

    // Escape fires 'close' too, so scroll and focus are restored in one place.
    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (opener && opener.focus) opener.focus();
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[data-bsp-zoom]') : null;
    if (!a) return;
    if (!window.HTMLDialogElement) return;                       // plain link fallback
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // let "open in new tab" work
    e.preventDefault();
    build();
    var group = a.closest('[data-bsp-group]') || document;
    items = Array.prototype.slice.call(group.querySelectorAll('a[data-bsp-zoom]'));
    opener = a;
    show(items.indexOf(a));
    document.documentElement.style.overflow = 'hidden';
    dlg.showModal();
  });
})();
